import { useRef, useState } from "react";

export default function useRecorder() {
  const [recording, setRecording] = useState(false);
  const recRef = useRef(null);
  const chunks = useRef([]);

  const start = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const rec = new MediaRecorder(stream);
    chunks.current = [];
    rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
    rec.start();
    recRef.current = rec;
    setRecording(true);
  };

  const stop = () =>
    new Promise((resolve) => {
      const rec = recRef.current;
      if (!rec) return resolve(null);
      rec.onstop = () => {
        rec.stream.getTracks().forEach((t) => t.stop());
        resolve(new Blob(chunks.current, { type: "audio/webm" }));
      };
      rec.stop();
      setRecording(false);
    });

  return { recording, start, stop };
}
